import React, { useEffect, useState } from "react";
import { CompanyAPI, ProjectAPI } from "../services/api";
import { useNavigate } from "react-router-dom";

const CompanyAddUser = () => {
  const navigate = useNavigate();

  const [companyUsers, setCompanyUsers] = useState<any[]>([]);
  const [projects, setProjects] = useState<any[]>([]);

  const [selectedEmail, setSelectedEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("user");

  // NEW
const [updateEmail, setUpdateEmail] = useState("");
const [updateRole, setUpdateRole] = useState("user");

  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const [projectUsers, setProjectUsers] = useState<any[]>([]);

  const [assignProject, setAssignProject] = useState<number | null>(null);
  const [assignUserEmail, setAssignUserEmail] = useState("");

  const [availableUsers, setAvailableUsers] = useState<string[]>([]);

  // 🔄 LOAD DATA
  const loadData = async () => {
    try {
      const usersRes = await CompanyAPI.getUsers();
      setCompanyUsers(usersRes.data || []);
    } catch {}

    try {
      const projectsRes = await ProjectAPI.getAll();
      setProjects(projectsRes || []);
    } catch {}

    // ✅ ADD THIS BLOCK HERE
  try {
    const availableRes = await CompanyAPI.getAvailableUsers();
    setAvailableUsers(availableRes.data || []);
  } catch {}
  };

  useEffect(() => {
    loadData();
  }, []);

  // ⏱ AUTO CLEAR MESSAGE
  useEffect(() => {
    if (message || error) {
      const timer = setTimeout(() => {
        setMessage(null);
        setError(null);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [message, error]);

  // ➕ ADD USER
  const handleAddUser = async () => {
    if (!selectedEmail) return;

    try {
      const res: any = await CompanyAPI.addUser({
        email: selectedEmail,
        role: selectedRole,
      });

      setMessage(res.data?.message || "User added to company");
      setSelectedEmail("");
      loadData();
    } catch (err: any) {
      setError(err.response?.data?.message || "Failed to add user");
    }
  };

const loadUserRole = async (email: string) => {
    if (!email) return;

    try {
        const res: any = await CompanyAPI.getUserRole(email);
        setUpdateRole(res.data?.role ?? res.role ?? "user");
    } catch {
        setError("Unable to load role");
    }
};

const handleUpdateRole = async () => {
    if (!updateEmail) {
        setError("Select a user");
        return;
    }

    const currentUser = companyUsers.find(
        (u) => u.email === updateEmail
    );

    if (
        currentUser &&
        currentUser.userType?.toLowerCase() === updateRole.toLowerCase()
    ) {
        setMessage(`User already has '${updateRole}' role.`);
        return;
    }

    try {
        const res: any = await CompanyAPI.updateUserRole({
            email: updateEmail,
            role: updateRole,
        });

        setMessage(res.data?.message || "Role updated successfully");

        loadData();

        setUpdateEmail("");
        setUpdateRole("user");
    } catch (err: any) {
        setError(err.response?.data?.message || "Failed to update role");
    }
};


  // ❌ REMOVE USER (COMPANY)
  const handleRemoveUser = async (email: string) => {
    try {
      const res: any = await CompanyAPI.removeUser({ email });

      setMessage(res.data?.message || "User removed from company");
      loadData();
    } catch {
      setError("Failed to remove user");
    }
  };

  // 👥 SEE USERS
  const handleSeeUsers = async (projectNo: number) => {
    if (selectedProject === projectNo) {
      setSelectedProject(null);
      return;
    }

    setAssignProject(null);
    setSelectedProject(projectNo);

    try {
      const users = await ProjectAPI.getUsers(projectNo);
      setProjectUsers(users);
    } catch {
      setError("Failed to load users");
    }
  };

  // ❌ REMOVE USER FROM PROJECT
  const handleRemoveFromProject = async (projectNo: number, email: string) => {
    try {
      const res: any = await CompanyAPI.removeUserFromProject({
        projectNo,
        email,
      });

      setMessage(res.data?.message || "User removed from project");
      handleSeeUsers(projectNo);
    } catch {
      setError("Failed to remove user from project");
    }
  };

  // ➕ ASSIGN USER
  const handleAssignUser = async (projectNo: number) => {
    if (!assignUserEmail) return;

    try {
      const res: any = await CompanyAPI.assignUserToProject({
        projectNo,
        email: assignUserEmail,
      });

      setMessage(res.data?.message || "User assigned to project");

      setAssignUserEmail("");
      setAssignProject(null);

      handleSeeUsers(projectNo);
    } catch {
      setError("Failed to assign user");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">

      <h1 className="text-2xl font-bold mb-6">Company Dashboard</h1>

      {/* 👥 COMPANY USERS */}
      <div className="bg-white p-4 rounded shadow mb-6">
        <h2 className="font-semibold mb-3">Company Users</h2>

        {companyUsers.map((u, i) => (
          <div key={i} className="flex justify-between border p-2 mb-2 rounded">
            <span>{u.email}</span>

            <button
              onClick={() => handleRemoveUser(u.email)}
              className="text-red-500 text-sm"
            >
              Remove
            </button>
          </div>
        ))}
      </div>

      {/* ➕ ADD USER */}
      <div className="bg-white p-4 rounded shadow mb-6">
        <h2 className="font-semibold mb-3">Add User</h2>

        {/*<input
          value={selectedEmail}
          onChange={(e) => setSelectedEmail(e.target.value)}
          placeholder="Enter email"
          className="border p-2 w-full mb-3 rounded"
        />
        {selectedEmail && (
  <select
    value={selectedEmail}
    onChange={(e) => setSelectedEmail(e.target.value)}
    className="border p-2 w-full mb-3 rounded"
  >
    <option value={selectedEmail}>
      {selectedEmail}
    </option>
  </select>
)}*/}
 <div className="mb-3"> 


  {/* INPUT */}
  <input
    value={selectedEmail}
    onChange={(e) => setSelectedEmail(e.target.value)}
    placeholder="Enter email"
    className="border p-2 w-full rounded"
  />

  {/* DROPDOWN */}
  {selectedEmail && (
    // <div className="absolute z-10 w-full bg-white border rounded shadow">
    <div className="mt-1 w-full bg-white border rounded shadow max-h-40 overflow-y-auto">

      {availableUsers
        .filter(email =>
          email.toLowerCase() === selectedEmail.toLowerCase()
        )
        .map((email, i) => (
          <div
            key={i}
            onClick={() => setSelectedEmail(email)}
            className="p-2 hover:bg-blue-100 cursor-pointer text-sm"
          >
            {email}
          </div>
        ))}

      {!availableUsers.some(
        email => email.toLowerCase() === selectedEmail.toLowerCase()
      ) && (
        <div className="p-2 text-red-400 text-sm">
          User not available or already assigned
        </div>
      )}

    </div>
  )}
</div>

        <select
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
          className="border p-2 w-full mb-3 rounded"
        >
          <option value="superadmin">Super Admin</option>
          <option value="admin">Admin</option>
          <option value="user">Normal User</option>
          <option value="client">Client</option>
         
        </select>

        <button
          onClick={handleAddUser}
          className="bg-green-600 text-white px-4 py-2 rounded w-full"
        >
          Add User
        </button>
      </div>

      {/* 🔄 UPDATE USER ROLE */}
<div className="bg-white p-4 rounded shadow mb-6">
  <h2 className="font-semibold mb-3">
    Update User Role
  </h2>

  <select
    value={updateEmail}
    onChange={async (e) => {
      const email = e.target.value;
      setUpdateEmail(email);

      if (email) {
        await loadUserRole(email);
      }
    }}
    className="border p-2 w-full mb-3 rounded"
  >
    <option value="">Select User</option>

    {companyUsers.map((u, i) => (
      <option key={i} value={u.email}>
        {u.email}
      </option>
    ))}
  </select>

  <select
    value={updateRole}
    onChange={(e) => setUpdateRole(e.target.value)}
    className="border p-2 w-full mb-3 rounded"
  >
    <option value="superadmin">Super Admin</option>
    <option value="admin">Admin</option>
    <option value="user">Normal User</option>
    
  </select>

  <button
    onClick={handleUpdateRole}
    className="bg-blue-600 text-white px-4 py-2 rounded w-full"
  >
    Update Role
  </button>
</div>

      {/* 📁 PROJECTS */}
      <div className="bg-white p-4 rounded shadow">

        {/* 🔵 HEADER */}
        <div className="flex justify-between items-center mb-3">
          <h2 className="font-semibold">Company Projects</h2>

          <button
            onClick={() => navigate("/")}
            className="bg-blue-600 text-white px-3 py-1 rounded text-sm"
          >
            Open Projects Page
          </button>
        </div>

        {projects.map((p) => (
          <div key={p.projectNo} className="border p-3 mb-3 rounded">

            <div className="flex justify-between items-center">
              <span>{p.projectName}</span>

              <div className="flex gap-4">
                <button
                  onClick={() => handleSeeUsers(p.projectNo)}
                  className="text-blue-600 underline text-sm"
                >
                  See Users
                </button>

              {/*  <button
                  onClick={() => {
                    setSelectedProject(null);
                    setAssignProject(p.projectNo);
                  }}
                  className="text-purple-600 underline text-sm"
                >
                  Assign User
                </button> */}
                <button
  onClick={async () => {
    setSelectedProject(null);
    setAssignProject(p.projectNo);

    // ✅ ADD THIS PART
    try {
      const users = await ProjectAPI.getUsers(p.projectNo);
      setProjectUsers(users);
    } catch {
      setError("Failed to load users");
    }
  }}
  className="text-purple-600 underline text-sm"
>
  Assign User
</button>

              </div>
            </div>

            {/* USERS */}
            {selectedProject === p.projectNo && (
              <div className="mt-4 border-t pt-3">
                <h3 className="font-semibold mb-2">Users</h3>

                {projectUsers.map((u, i) => (
                  <div key={i} className="flex justify-between mb-2">
                    <span>{u.email}</span>

                    <button
                      onClick={() =>
                        handleRemoveFromProject(p.projectNo, u.email)
                      }
                      className="text-red-500 text-sm"
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* ASSIGN */}
            {assignProject === p.projectNo && (
              <div className="mt-4 border-t pt-3">

                <select
                  value={assignUserEmail}
                  onChange={(e) => setAssignUserEmail(e.target.value)}
                  className="w-full border p-2 rounded mb-2"
                >
                  <option value="">Select User</option>

                  {companyUsers
                    .filter(u => u.userType?.toLowerCase() === "user")
                    .filter(u =>
                      !projectUsers.some(pu => pu.email === u.email)
                    )
                    .map((u, i) => (
                      <option key={i} value={u.email}>
                        {u.email}
                      </option>
                    ))}
                </select>

                <button
                  onClick={() => handleAssignUser(p.projectNo)}
                  className="w-full bg-purple-600 text-white py-2 rounded"
                >
                  Assign
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* 🔔 TOAST */}
      {message && (
        <div className="fixed top-4 right-4 bg-green-600 text-white px-4 py-2 rounded shadow">
          {message}
        </div>
      )}

      {error && (
        <div className="fixed top-4 right-4 bg-red-500 text-white px-4 py-2 rounded shadow">
          {error}
        </div>
      )}
    </div>
  );
};

export default CompanyAddUser;